import React from "react";
import logo from "../assets/logo.svg";
import { Link, useHistory } from "react-router-dom";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import LoginForm from "../component/LoginForm";
import { useAuth } from "../context/authContext";

const Login = () => {
  const auth = useAuth();
  const history = useHistory();

  const login = async (data) => {
    await auth
      .login(data)
      .then((res) => {
        history.push("/dashboard/index");
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return (
    <Flex sx={{ minHeight: "100vh" }} justify="center" bg="#223D5D" py={8}>
      <Box>
        <Center>
          <Center>
            <Link to="/">
              <img height="126px" width="345px" src={logo} alt="logo" />
            </Link>
          </Center>
        </Center>

        <Box
          bg="white"
          mt={6}
          pt={16}
          sx={{
            maxWidth: "445px",
            minHeight: "447px",
            borderRadius: "10px",
            fontWeight: 510,
          }}
        >
          <LoginForm login={login} />

          <Box sx={{ borderRadius: "inherit" }}>
            <Box px={8}>
              <Link>
                <Flex mt={10}>
                  <Box color="#223D5D">
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </Box>
                  <Link to="/forgot-password">
                    <Text color="#00A2E8" pl={5} m={0}>
                      Forgot Password
                    </Text>
                  </Link>
                </Flex>
              </Link>
            </Box>

            <Box
              bg="#F6F7F8"
              py={4}
              mt={8}
              sx={{ textAlign: "center", borderRadius: "inherit" }}
            >
              <Center>
                <Text mr="1">Don't Have an account?</Text>
                <Link to="/register">
                  <Text color="#00A2E8">Register</Text>
                </Link>
              </Center>
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default Login;
